import { Controller } from "remult";

@Controller("call-center-alert-methods")
export class CallCenterAlertMethods {}
